import DataDisplaysColorizedCategorizableController from "../../../data_displays/assets/javascript/data-displays-colorized-categorizable-controller";

export default class extends DataDisplaysColorizedCategorizableController {
  focus(event) {
    dispatchCustomEvent(this.focusEventName, this.element, { color: this.color })
  }

  unfocus(event) {
    dispatchCustomEvent(this.unfocusEventName, this.element, { color: this.color })
  }
}



// WEBPACK FOOTER //
// ./app/components/billing_categories/assets/javascript/billing-categories-category-summary-row-controller.js